<template>
    <!--醫院介紹 第三版-->
    <v-flex row wrap xs12 sm12 md12 lg12  >

        <v-flex class="xs12 sm12 md8  mt-5 ml-5 mr-5"  >

            <!--<img :src="docImage" class="imgShadow">-->

            <div class="text-center">
                <img
                        :src="docImage"
                        aspect-ratio="1"
                        class="lighten-2 imgShadow3"
                        width="300px"
                        style="margin-bottom: 15px">
            </div>


            <div class="divHospDoc3 mt-2 ml-3" v-html="hospDoc"></div>

        </v-flex>

        <v-flex v-if="selfDiv=='OFF'" class="xs12 sm12 md3 mt-5 ml-5 mr-5 pl-3 divItemBg3">

                <div  cols="12" sm="12" md="12" style="width: 100%;padding: 3px" v-for="(item, i) in divNoList" :key="i" @click="clickDivBtn(item.divNo)"
                     class="divNoItem3 divNoBtnBg3 elevation-3 mt-4" >
                            {{item.divName}}
                </div>

        </v-flex>

        <v-flex v-else class="xs12 sm12 md3 mt-5 ml-5 mr-5 pl-3 divItemBg3">

            <div  cols="12" sm="12" md="12" style="width: 100%;padding: 3px" v-for="(item, i) in divNoList" :key="i" @click="clickSelfDivBtn(item.value3,item.value1)"
                  class="divNoItem3 divNoBtnBg3 elevation-3 mt-4" >
                {{item.value2}}
            </div>

        </v-flex>

        <!-- 我是 snackbar -->
        <v-snackbar
                :timeout="snTimeout"
                v-model="snStatus">
            {{snText}}
        </v-snackbar>
    </v-flex>
</template>

<script>
    export default {
        name: "HospC",
        data() {
            return {
                chipGroup:-1,
                snTimeout:4000,
                snStatus:false,
                snText:'',
                loading: false,
                hospDoc:'',
                docType:'HOSP',
                docImage:'',
                divNoList:[],
                selfDiv:'OFF',
                divTheme:'DivA',
            }
        },
        created(){
            let zone = this.$route.query.zone==undefined?this.$store.state.AppSetting.zone:this.$route.query.zone;
            this.axios_getHospDocListData(this.docType,zone);
            // this.axios_getDivNoList();//取得科別清單
            this.axios_getRegCondSelfDiv();
            this.axios_getSysTheme();
        },
        watch: {
            '$route.params': function () {
                let zone = this.$route.query.zone==undefined?this.$store.state.AppSetting.zone:this.$route.query.zone;
                this.axios_getHospDocListData(this.docType,zone);
                // this.axios_getDivNoList();//取得科別清單
                this.axios_getRegCondSelfDiv();
                this.axios_getSysTheme();
            },
        },
        methods:{
            findSelfDivZone(divNo){
                return this.divNoList.filter((i) => {
                    return (i.value4==divNo) ;
                })
            },
            clickDivBtn(divCode){ //點完後 連結去科別介紹
                this.$router.push({name: this.divTheme, params:{divCode:divCode},query:{zone:this.$route.query.zone}});
            },
            clickSelfDivBtn(divCode,selfDiv){ //點完後 連結去科別介紹
                this.$router.push({name: this.divTheme, params:{divCode:divCode,selfDiv:selfDiv},query:{zone:this.$route.query.zone}});
            },
            axios_getHospDocListData (docType,docCode){ //查詢科別醫院簡介
                this.loading = true;
                this.hospDoc = '';
                this.docImage = '';
                let url = '';
                let zone = this.$route.query.zone==undefined?this.$store.state.AppSetting.zone:this.$route.query.zone;
                url = this.$store.state.AppSetting.backSrvUrl + "hospdoc/datasearch/primarykeys/"+zone+"/"+docType+"/"+docCode;

                this.$http.get(url).then(response =>{
                    if(response.data.status == 'INFO' && response.data.hasOwnProperty('resultSet') && response.data.resultSet.length>0){
                        this.hospDoc = response.data.resultSet[0].hospDoc;
                        this.docImage = response.data.resultSet[0].docImage
                    }else{
                        this.loading = false;
                        this.hospDoc ='';
                        this.docImage ='';
                    }
                    this.loading = false;
                }).catch(error =>  {
                    this.loading = false;
                    try {
                        console.log(error.response.data.status);
                        this.hospDoc = '';
                        this.docImage = '';
                    } catch(err) {
                        this.hospDoc = '';
                        this.docImage = '';
                    }
                });
            },
            axios_getDivNoList(){ //取得科別清單
                this.divNoList = [];
                let zone = this.$route.query.zone==undefined?this.$store.state.AppSetting.zone:this.$route.query.zone;
                let url = '';
                url = this.$store.state.AppSetting.backSrvUrl + "division/datasearch/telandsubdiv/"+zone;

                this.$http.get(url).then(response=>{
                    if(response.data.resultSet.length>0&& response.data.hasOwnProperty('resultSet')){
                        this.divNoList = response.data.resultSet;
                    }
                }).catch(error =>{
                    this.divNoList = [];
                    try{
                        this.snStatus=true;
                        this.snText = error.response.data.message;
                    }catch (e) {
                        this.snStatus=true;
                        this.snText = error.response.data.message;
                    }
                });
            },
            axios_getRegCondSelfDiv(){ //20210112  是否使用自訂義科別 查詢設定檔
                let url = '';
                url = this.$store.state.AppSetting.backSrvUrl + "iregsetting/datasearch/bygroupidcode/REGCOND/SELF_DIV";

                this.$http.get(url).then(response =>{
                    if(response.data.status == 'INFO' && response.data.hasOwnProperty('resultSet') && response.data.resultSet.length>0){
                        this.selfDiv = response.data.resultSet[0].value1;
                        if(this.selfDiv=='ON'){
                            this.axios_getSelfDivAllData();
                        }else {
                            this.axios_getDivNoList();
                        }


                    }else{
                        this.selfDiv = 'OFF'
                        this.axios_getDivNoList();
                    }


                }).catch(error =>  {
                    try {
                        this.selfDiv = 'OFF'
                        console.log(error.response.data.status);

                    } catch(err) {
                        this.selfDiv = 'OFF'
                    }
                    this.axios_getDivNoList();

                });

            },
            axios_getSelfDivAllData (){ //查詢某院區全部自訂義科別
                this.divNoList = [];
                let url = '';
                let zone = this.$route.query.zone==undefined?this.$store.state.AppSetting.zone:this.$route.query.zone;
                // url = this.$store.state.AppSetting.backSrvUrl + "hospdoc/datasearch/primarykeys/"+zone+"/SELFDIV/ALL";
                url = this.$store.state.AppSetting.backSrvUrl + "iregsetting/datasearch/bygroupidcode/SELFDIV/ALL";

                this.$http.get(url).then(response =>{
                    if(response.data.status == 'INFO' && response.data.hasOwnProperty('resultSet') && response.data.resultSet.length>0){
                        this.divNoList = response.data.resultSet;
                        this.divNoList = this.findSelfDivZone(zone);
                    }else{
                        this.divNoList = [];

                    }
                }).catch(error =>  {

                    try {
                        console.log(error.response.data.status);
                        this.divNoList = [];
                    } catch(err) {
                        this.divNoList = [];
                    }
                });
            },
            //查詢樣式 1100113
            axios_getSysTheme (){ //查詢樣式theme設定檔
                let url = '';
                this.divTheme = 'DivA';
                url = this.$store.state.AppSetting.backSrvUrl + "iregsetting/datasearch/bygroupidcode/BASEINFO/THEME";

                this.$http.get(url).then(response =>{
                    if(response.data.status == 'INFO' && response.data.hasOwnProperty('resultSet') && response.data.resultSet.length>0){
                        this.divTheme = response.data.resultSet[0].value2;

                    }else{
                        this.divTheme = 'DivA';
                    }


                }).catch(error =>  {
                    try {
                        console.log(error.response.data.status);
                        this.divTheme = 'DivA';
                    } catch(err) {
                        this.divTheme = 'DivA';
                    }

                });


            },
        }
    }
</script>

<style scoped>



</style>